jQuery(document).ready(function ($) {
  $('body').on('focusin', '.gfield input', function (e) {
    var $this = $(this);
    $this.closest('.gfield').addClass('-pre-focusin');
  });
  $('body').on('focusout', '.gfield input', function (e) {
    var $this = $(this);
    var value = $this.val().trim();
    var $parent = $this.closest('.gfield');

    if (value) {
      $parent.addClass('-pre-focusin');
      return;
    }

    $parent.removeClass('-pre-focusin');
  });
});
"use strict";

function getTop() {
  return jQuery(window).scrollTop();
}

function isIE11() {
  return !!window.MSInputMethodContext && !!document.documentMode;
}

;

(function (window, document, $) {
  $.fn.doSlickSlide = function (direction) {
    var self = $(this),
        slickSection = self.closest('.slick-section');
    if (slickSection.length > 0) slickSection.find('.slick-slider').slick(direction);
    return this;
  };

  $('.slick-next').on('click', function () {
    $(this).doSlickSlide('slickNext');
  });
  $('.slick-prev').on('click', function () {
    $(this).doSlickSlide('slickPrev');
  });
  $.easing['jswing'] = $.easing['swing'];
  $.extend(jQuery.easing, {
    easeInOutExpo: function easeInOutExpo(x, t, b, c, d) {
      if (t == 0) return b;
      if (t == d) return b + c;
      if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    }
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  ;

  (function () {
    /** Page scroll */
    var htmlBody = $('html, body');
    var $site_navbar = $('#site_navbar');
    $('.scroll-to').on('click', function (e) {
      e.preventDefault();
      var anchor = $(this),
          target = anchor.attr('href'),
          $section = $(target).first();

      if ($section.length > 0) {
        var scrollTop = $section.offset().top - $site_navbar.outerHeight(false);
        htmlBody.stop().animate({
          scrollTop: scrollTop
        }, 1000, 'easeInOutExpo');
      }
    });
  })();

  ;

  (function () {
    var galleries = [{
      element: '.gallery .gallery__row',
      selector: '.gallery__item'
    }, {
      element: '.gallery .gallery__slider',
      selector: '.gallery__item'
    }];
    var i;

    var _loop = function _loop() {
      var lightgallery = $(galleries[i].element);
      var selector = galleries[i].selector;

      if (lightgallery.length > 0) {
        lightgallery.lightGallery({
          pager: false,
          // Enable/Disable pager
          selector: selector,
          // Custom selector property instead of just child. pass this to select same element ex : .class #id
          zoom: false,
          // Enable/Disable zoom option
          autoplayControls: false,
          // Show/hide autoplay controls.
          download: false,
          // Enable download button. By default download url will be taken from data-src/href attribute but it supports only for modern browsers. If you want you can provide another url for download via data-download-url. Pass false in data-download-url if you want to hide download button for the particular slide.
          thumbnail: false,
          animateThumb: false,
          showThumbByDefault: false
        });
        /**
         * Note: true - If you pass true as a parameter destroy method will destroy the gallery completely.
         *      If parameter is undefined or false destroy will only close the gallery and plugins instance remains with the element.
         */

        $('body').on('click touchstart', '.lg-close', function () {
          lightgallery.data('lightGallery').destroy(false);
        });
      }
    };

    for (i = 0; i < galleries.length; i++) {
      _loop();
    }

    var $slider = $('.gallery .gallery__slider');
    var options = {
      mobileFirst: true,
      slidesToShow: 1,
      //slidesToScroll: 1,
      //centerPadding: '60px',
      slidesToScroll: 1,
      //variableWidth: true,
      dots: false,
      centerMode: true,
      focusOnSelect: true,
      infinite: true,
      rtl: raveh_ravid_is_rtl(),
      responsive: [{
        breakpoint: 991,
        settings: 'unslick'
      }]
    };

    var slick_initialized = function slick_initialized() {
      return $slider.hasClass('slick-initialized');
    };

    window.innerWidth <= 991 && $slider.slick(options);

    var orientationchange = function orientationchange() {
      slick_initialized() && $slider.slick('unslick');
      $slider.slick(options);
    };

    $(window).on('orientationchange', orientationchange);
    $('.testi_slider.testimonial__slider').slick($.extend(options, {
      responsive: false,
      useCSS: true
    }));
  })();
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict"; // values to keep track of the number of letters typed, which quote to use. etc. Don't change these values.

  var i = 0,
      a = 0,
      isBackspacing = false,
      isParagraph = false; // Typerwrite text content. Use a pipe to indicate the start of the second line "|".

  var textArray = ["What do you call an alligator wearing a vest 1", "What do you call an alligator wearing a vest 2", "What do you call an alligator wearing a vest 3"];
  var $letters_typed = $('.letters-typed');
  if ($letters_typed.length <= 0) return; // Speed (in milliseconds) of typing.

  var speedForward = 125,
      //Typing Speed
  speedWait = 2200,
      // Wait between typing and backspacing
  speedBetweenLines = 1000,
      //Wait between first and second lines
  speedBackspace = 25; //Backspace Speed

  function typeWriter(id, ar) {
    var $element = $("#" + id);

    if (window.parseInt($element.length) === 0) {
      throw new Error('typeWriter element does not exist.');
    } else if (ar instanceof Array === false) {
      throw new Error('typeWriter ar variable must to be an Array.');
    } else if (window.parseInt(ar.length) === 0) {
      throw new Error('typeWriter ar must to contain at least one string value.');
    }

    var aString = ar[a],
        eHeader = $element.find('.letters-typed__caption').first(),
        //Header element
    eParagraph = null; //Subheader element

    if (window.parseInt(eHeader.length) === 0) {
      throw new Error('Child element .letters-typed__caption does not exist.');
    } // Determine if animation should be typing or backspacing


    if (!isBackspacing) {
      // If full string hasn't yet been typed out, continue typing
      if (i < aString.length) {
        // If character about to be typed is a pipe, switch to second line and continue.
        if (aString.charAt(i).toString() === '|') {
          isParagraph = true;
          eHeader.removeClass("cursor");
          eParagraph && eParagraph.addClass("cursor");
          i++;
          window.setTimeout(function () {
            typeWriter(id, ar);
          }, speedBetweenLines); // If character isn't a pipe, continue typing.
        } else {
          // Type header or subheader depending on whether pipe has been detected
          if (!isParagraph) {
            eHeader.text(eHeader.text() + aString.charAt(i));
          } else {
            eParagraph && eParagraph.text(eParagraph.text() + aString.charAt(i));
          }

          i++;
          window.setTimeout(function () {
            typeWriter(id, ar);
          }, speedForward);
        } // If full string has been typed, switch to backspace mode.

      } else if (i === window.parseInt(aString.length)) {
        isBackspacing = true;
        window.setTimeout(function () {
          typeWriter(id, ar);
        }, speedWait);
      } // If backspacing is enabled

    } else {
      // If either the header or the paragraph still has text, continue backspacing
      if (eHeader.text().length > 0 || false && eParagraph.text().length > 0) {
        // If paragraph still has text, continue erasing, otherwise switch to the header.
        if (eParagraph && eParagraph.text().length > 0) {
          eParagraph.text(eParagraph.text().substring(0, eParagraph.text().length - 1));
        } else if (eHeader.text().length > 0) {
          eParagraph && eParagraph.removeClass("cursor");
          eHeader.addClass("cursor");
          eHeader.text(eHeader.text().substring(0, eHeader.text().length - 1));
        }

        window.setTimeout(function () {
          typeWriter(id, ar);
        }, speedBackspace); // If neither head or paragraph still has text, switch to next quote in array and start typing.
      } else {
        isBackspacing = false;
        i = 0;
        isParagraph = false;
        a = (a + 1) % ar.length; //Moves to next position in array, always looping back to 0

        window.setTimeout(function () {
          typeWriter(id, ar);
        }, 50);
      }
    }
  }

  $letters_typed.each(function () {
    var $this_typed = $(this);
    var output_id = $this_typed.children('.letters-typed__output').attr('id');
    var sentences = $this_typed.data('sentences');
    typeWriter(output_id, sentences);
  }); //Run the loop
  //typeWriter("output", sentences);
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    var $position_collapse = $(".position__collapse");

    var toggle = function toggle() {
      var button_class_name = 'position__button--close';

      var toggle = function toggle() {
        var $collapse = $(this);
        var $position = $collapse.closest('.position');
        var $button = $position.find('[data-toggle="collapse"]');
        var text = $button.data('text');
        return {
          $button: $button,
          text: text
        };
      };

      return {
        show: function show() {
          var _toggle$call = toggle.call(this),
              $button = _toggle$call.$button,
              text = _toggle$call.text;

          $button.addClass(button_class_name).text(text.hide);
        },
        hide: function hide() {
          var _toggle$call2 = toggle.call(this),
              $button = _toggle$call2.$button,
              text = _toggle$call2.text;

          $button.removeClass(button_class_name).text(text.show);
        }
      };
    };

    var _toggle = toggle(),
        show = _toggle.show,
        hide = _toggle.hide; // The collapsible content is about to be shown


    $position_collapse.on('show.bs.collapse', show); // The collapsible content is about to be hidden.

    $position_collapse.on('hide.bs.collapse', hide);
  });
  $('#positions-modal').on('shown.bs.modal', function (e) {
    var initiator = e.relatedTarget;
    var positionNumber = initiator.dataset.position;
    var input = e.currentTarget.querySelector('.upload-file + li input[type="hidden"]');
    input.value = positionNumber;
    console.log(input);
  });
})(window, document, jQuery);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

jQuery(document).ready(function ($) {
  var Comp_Factory = /*#__PURE__*/function () {
    function Comp_Factory($, CLASS_NAME) {
      _classCallCheck(this, Comp_Factory);

      this.$ = $;
      this.CLASS_NAME = CLASS_NAME;
    }

    _createClass(Comp_Factory, [{
      key: "open",
      value: function open() {
        this.$.addClass(this.CLASS_NAME);
      }
    }, {
      key: "close",
      value: function close() {
        this.$.removeClass(this.CLASS_NAME);
      }
    }, {
      key: "toggle",
      value: function toggle() {
        this.$.toggleClass(this.CLASS_NAME);
      }
    }, {
      key: "is_open",
      value: function is_open() {
        return this.$.hasClass(this.CLASS_NAME);
      }
    }]);

    return Comp_Factory;
  }();

  var $body = $('body');
  var $site_navbar = $('#site_navbar');
  var $site_overlay = $('#site_overlay');
  var navbar_menu = new Comp_Factory($site_navbar, '-pre-menu--open');
  var overlay = new Comp_Factory($site_overlay, '-pre-overlay--in');

  var close_if_clicked_outside = function close_if_clicked_outside(cb) {
    var menu = this; // Close menu if clicked outside of the menu container

    $(document).mouseup(function (e) {
      if (!menu.is(e.target) // if the target of the click isn't the container...
      && menu.has(e.target).length === 0 // ... nor a descendant of the container
      && e.which === 1) {
        cb && cb(e);
      }
    });
  };

  getTop() > 0 && $site_navbar.addClass('-pre-site-navbar--scroll');
  $site_navbar.addClass('-pre-site-navbar--init');

  var handle_navbar_scroll = function handle_navbar_scroll(event) {
    if (getTop() === 0) $site_navbar.removeClass('-pre-site-navbar--scroll');else $site_navbar.addClass('-pre-site-navbar--scroll');
  };

  $(window).on('scroll', handle_navbar_scroll);
  ;

  (function () {
    var $navbar_hamburger = $site_navbar.find('.hamburger-toggle');

    var hamburger_toggle = function hamburger_toggle() {
      var event = jQuery.Event('click', {
        keyCode: 1
      });
      $navbar_hamburger.trigger(event);
    };

    var open_menu = function open_menu(e) {
      if (navbar_menu.is_open()) {
        navbar_menu.close();
        overlay.close();
        return;
      }

      navbar_menu.open();
      overlay.open();
    };

    var clicked_outside = function clicked_outside(e) {
      var $target_element = $(e.target);
      navbar_menu.is_open() && $target_element.closest('.site-navbar__hamburger').length === 0 && hamburger_toggle();
    };

    $body.on('click', '.overlay.-pre-overlay--in', function (e) {
      return window.innerWidth >= 768 && open_menu(e);
    });
    $site_navbar.find('.hamburger-toggle').on('click', function (e) {
      return open_menu(e);
    });
    $site_navbar.find('.site-navbar__col-menu').first().on('click', function (e) {
      var $this = $(this);

      if ($this.is(e.target)) {
        open_menu(e);
      }
    });
  })();
});
;

(function (window, document, $) {
  "use strict";

  ;

  (function () {
    var tabs = document.querySelectorAll('[role="tab"]');
    var tabList = document.querySelector('[role="tablist"]');
    if (!tabList) return;

    function changeTabs() {
      var target = $(this);
      var parent = target.parent();
      var grandparent = parent.parent(); // Remove all current selected tabs

      grandparent.find('[aria-selected="true"]').attr("aria-selected", false); // Set this tab as selected

      target.attr("aria-selected", true);
    } // Occurs when the tab is about to be shown


    $('.nav-pills a').on('show.bs.tab', changeTabs); // Enable arrow navigation between tabs in the tab list

    var tabFocus = 0;
    tabList.addEventListener('keydown', function (e) {
      // Move right
      if (e.keyCode === 39 || e.keyCode === 37) {
        tabs[tabFocus].setAttribute("tabindex", -1);

        if (e.keyCode === 39) {
          tabFocus++; // If we're at the end, go to the start

          if (tabFocus >= tabs.length) {
            tabFocus = 0;
          } // Move left

        } else if (e.keyCode === 37) {
          tabFocus--; // If we're at the start, move to the end

          if (tabFocus < 0) {
            tabFocus = tabs.length - 1;
          }
        }

        tabs[tabFocus].setAttribute("tabindex", 0);
        window.setTimeout(function () {
          return tabs[tabFocus].focus();
        }, 0);
      }
    });
  })();
})(window, document, jQuery);